import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import DoneIcon from '@mui/icons-material/Done';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import {
  AlertVariant,
  AlertStyleVariant,
  useAlert,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Alert';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { AppRoutes } from 'types';

const tAssignment = (key, options?) => translate('assignment', key, options);

const useAssignmentSuccessAlert = (letter: string): { handleSuccessSaveAlert: () => void } => {
  const navigate = useNavigate();
  const [, { openAlert, closeAlert }] = useAlert();

  const classes = useStyles();

  const goToEditLetter = () => {
    closeAlert();
    navigate(`/${AppRoutes.ASSIGNMENTS}/edit/${letter}`);
  };

  const handleOpeningSuccessAlert = () => {
    const letters = `${letter.toUpperCase()}${letter.toLowerCase()}`;
    openAlert({
      body: (
        <Typography variant="subtitle1">{tAssignment('saveSuccessAlert', { letters })}</Typography>
      ),
      variant: AlertVariant.SUCCESS,
      styleVariant: AlertStyleVariant.OUTLINED,
      options: {
        duration: 4000,
        classes: {
          icon: classes.icon,
          root: classes.alertRoot,
        },
      },
      alertProps: {
        icon: <DoneIcon />,
      },
      action: (
        <Button
          style={{ marginLeft: 40, color: theme.palette.primary.main }}
          onClick={goToEditLetter}
        >
          {tAssignment('editAssignment')}
        </Button>
      ),
    });
  };

  const handleSuccessSaveAlert = () => handleOpeningSuccessAlert();

  return { handleSuccessSaveAlert };
};

const useStyles = makeStyles((theme: any) => ({
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alertRoot: {
    backgroundColor: theme.palette.success.lighter,
    color: theme.palette.black.main,
  },
}));

export default useAssignmentSuccessAlert;
